/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionssaveanswer3Inputs */

const en_openquestionssaveanswer3 = /** @type {(inputs: Openquestionssaveanswer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const pt_openquestionssaveanswer3 = /** @type {(inputs: Openquestionssaveanswer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Openquestionssaveanswer3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionssaveanswer3 = /** @type {((inputs?: Openquestionssaveanswer3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionssaveanswer3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionssaveanswer3(inputs)
	return pt_openquestionssaveanswer3(inputs)
});
export { openquestionssaveanswer3 as "openQuestionsSaveAnswer" }